import React from 'react';
import LiveAutomationPanel from '../components/LiveAutomationPanel';
import CommissionerOnlyGate from '../components/CommissionerOnlyGate';
import LoadingState from '../components/LoadingState';
import { useLeague } from '../hooks/useLeague';
import { isLeagueArchived } from '../lifecycle';

function LiveAutomationSettingsContent() {
  const { league, loading, isOwner, refreshLeague, refreshLeagues } = useLeague();

  if (loading) return <LoadingState />;
  if (!league) return null;
  if (!isOwner) {
    return (
      <div className="card text-sm text-secondary-300" data-testid="live-automation-owner-only">
        Only the league owner can change live automation settings.
      </div>
    );
  }

  const archived = isLeagueArchived(league.status);

  return (
    <div className="space-y-6" data-testid="league-settings-live-automation">
      <div>
        <h2 className="text-xl font-bold text-white">Live Automation</h2>
        <p className="text-sm text-secondary-400 mt-1">
          Control when live streams can appear on League Home automatically.
        </p>
      </div>
      <LiveAutomationPanel
        league={league}
        leagueArchived={archived}
        onUpdated={async () => {
          await refreshLeague();
          await refreshLeagues();
        }}
      />
    </div>
  );
}

const LscSettingsLiveAutomationPage: React.FC = () => (
  <CommissionerOnlyGate>
    <LiveAutomationSettingsContent />
  </CommissionerOnlyGate>
);

export default LscSettingsLiveAutomationPage;
